module.exports = __webpack_public_path__ + "img/1556366372.bacac4c0.jpg";